//
// DO NOT EDIT. THIS FILE IS GENERATED.
//


                    import { Field, FieldType, StandardSumaryDataFieldsConfig, InventoryFileType, Section } from "./Models";
                    

export class StandardSummaryDataFieldsManager {
    public static getFieldAndAllSubChildrenInTree(field: Field): Field[] {
        return [
            field,
            ...(
                (field.childFields ?? [])
                    .selectMany(childField => StandardSummaryDataFieldsManager.getFieldAndAllSubChildrenInTree(childField))
                )
        ];
    }

    public static getAllFlattenedFieldsForSection = (section: Section): Field[] => section
        .fields
        .selectMany(f => StandardSummaryDataFieldsManager.getFieldAndAllSubChildrenInTree(f));

    public static getAllFlattenedFields = (): Field[] =>
        StandardSummaryDataFieldsManager.getConfig()
            .pages
            .selectMany(p => p.sections)
            .selectMany(s => s.fields)
            .selectMany(f => StandardSummaryDataFieldsManager.getFieldAndAllSubChildrenInTree(f));

    public static getAllFlattenedFileFields = (): Field[] =>
        StandardSummaryDataFieldsManager.getAllFlattenedFields()
            .filter(f => f.type === FieldType.MultipleFiles);

    /*

    public static getAllBulkImportFileDestinations = (): ImportFileDestination[] =>
        StandardSummaryDataFieldsManager.getConfig()
            .pages
            .map(p => ({ pageName: p.title, sectionFields: p.sections.selectMany(section => StandardSummaryDataFieldsManager.getAllFlattenedFieldsForSection(section)) }))
            .selectMany(tuple => tuple.sectionFields.filter(f => f.type === FieldType.MultipleFiles).map(f => ({
                fileType: StandardSummaryDataFieldsManager.inventoryFileTypeToImportFilesFileTypeMap[f.inventoryFileType],
                sourceId: 'toxnot-standard-pages',
                pageTitle: basePageViewController.localizeString(tuple.pageName),
                fieldTitle: basePageViewController.localizeString(f.label),
                summaryTableKey: f.summaryDataTableKey,
                validFileExtensions: null,
                validFileMetadataTypes: [
                    FileMetadataType.PlainDocument,
                    FileMetadataType.Certification
                ]
            })));

    private static readonly inventoryFileTypeToImportFilesFileTypeMap: Readonly<{ [key: number]: ImportFilesFileType }> = {
        [InventoryFileType.GeneralSupportingFile]: ImportFilesFileType.InventoryGeneralSupportingFile,
        [InventoryFileType.QuestionnaireFile]: ImportFilesFileType.InventoryQuestionnaireFile,
        [InventoryFileType.MetadataPageFile]: ImportFilesFileType.InventoryMetadataPageFile,
        [InventoryFileType.PhotoFile]: ImportFilesFileType.InventoryPhotoFile,
        [InventoryFileType.DeclareFile]: ImportFilesFileType.InventoryDeclareFile,
        [InventoryFileType.MsdsFile]: ImportFilesFileType.InventoryMsdsFile,
        [InventoryFileType.ComplianceGeneralFile]: ImportFilesFileType.InventoryComplianceGeneralFile,
        [InventoryFileType.ScipFile]: ImportFilesFileType.InventoryScipFile,
        [InventoryFileType.SustainabilityFile]: ImportFilesFileType.InventorySustainabilityFile,
        [InventoryFileType.CircularityFile]: ImportFilesFileType.InventoryCircularityFile,
        [InventoryFileType.GeneralSupportingFileHpd]: ImportFilesFileType.InventoryGeneralSupportingFileHpd,
        [InventoryFileType.GeneralSupportingFileC2c]: ImportFilesFileType.InventoryGeneralSupportingFileC2c,
        [InventoryFileType.GeneralSupportingFileVoc]: ImportFilesFileType.InventoryGeneralSupportingFileVoc,
        [InventoryFileType.GeneralSupportingFileOther]: ImportFilesFileType.InventoryGeneralSupportingFileOther,
        [InventoryFileType.HniEdsImageFile]: ImportFilesFileType.InventoryHniEdsImageFile,
        [InventoryFileType.SoldItemFile]: ImportFilesFileType.InventorySoldItemFile,
        [InventoryFileType.DynamicRegulationPageFile]: ImportFilesFileType.InventoryDynamicRegulationPageFile,
        [InventoryFileType.TdsFile]: ImportFilesFileType.InventoryTdsFile,
        [InventoryFileType.VocDataFile]: ImportFilesFileType.InventoryVocDataFile,
        [InventoryFileType.InstructionsFile]: ImportFilesFileType.InventoryInstructionsFile
    };

    */

    public static getConfig(): StandardSumaryDataFieldsConfig {
        return {
    "pages" : [
        {
            "title" : "Lifecycle Impacts",
            "questionnairePageType" : "Sustainability",
            "sections" : [
                {
                    "title" : "LCA\/EPD",
                    "questionnairePageType" : "SustainabilityEmbodiedCarbon",
                    "fields" : [
                        {
                            "type" : FieldType.FieldGroup,
                            "label" : "LCA\/EPD File",
                            "instructions" : "",
                            "childFields" : [
                                {
                                    "type" : FieldType.MultipleFiles,
                                    "label" : "EPD",
                                    "instructions" : "",
                                    "summaryDataTableKey" : "carbon_data_embodied_carbon_original_epd_files",
                                    "isExportable" : false,
                                    "inventoryFileType" : InventoryFileType.SustainabilityFile
                                },
                                {
                                    "type" : FieldType.TextInput,
                                    "label" : "EPD File URL",
                                    "instructions" : "Enter an optional url to the EPD file instead of uploading it above",
                                    "summaryDataTableKey" : "carbon_data_embodied_carbon_box_epd_file_download_url",
                                    "isExportable" : true
                                },
                                {
                                    "type" : FieldType.SelectCertification,
                                    "label" : "EPD Certification",
                                    "instructions" : "Adding a certification here will also link it to your product\/material. You can view it in the \"Certifications\" page on the left.",
                                    "summaryDataTableKey" : "carbon_data_embodied_carbon_epd_certification_id",
                                    "isExportable" : false
                                }
                            ]
                        },
                        {
                            "type" : FieldType.SingleSelectInput,
                            "label" : "LCA\/EPD Type",
                            "instructions" : "",
                            "summaryDataTableKey" : "carbon_data_embodied_carbon_lca_epd_type",
                            "enumType" : "CarbonDataLcaEpdAnswerType",
                            "options" : [
                                {
                                    "description" : "LCA (3rd Party)",
                                    "value" : "LcaThirdParty"
                                },
                                {
                                    "description" : "LCA (internal)",
                                    "value" : "LcaInternal"
                                },
                                {
                                    "description" : "LCA in Progress",
                                    "value" : "LcaInProgress"
                                },
                                {
                                    "description" : "Product Specific Epd",
                                    "value" : "ProductSpecificEpd"
                                },
                                {
                                    "description" : "Product Specific Epd in Progress",
                                    "value" : "ProductSpecificEpdInProgress"
                                }
                            ]
                        },
                        {
                            "type" : FieldType.FieldGroup,
                            "label" : "Embodied Carbon",
                            "instructions" : "",
                            "childFields" : [
                                {
                                    "type" : FieldType.TextInput,
                                    "label" : "Embodied Carbon Amount (kg CO2e\/unit)",
                                    "instructions" : "",
                                    "summaryDataTableKey" : "embodied_carbon_amount"
                                },
                                {
                                    "type" : FieldType.TextInput,
                                    "label" : "Embodied Carbon Product Unit",
                                    "instructions" : "",
                                    "summaryDataTableKey" : "embodied_carbon_product_unit",
                                    "isExportable" : true
                                },
                                {
                                    "type" : FieldType.MultiSelectInput,
                                    "label" : "Embodied Carbon Scope",
                                    "instructions" : "",
                                    "summaryDataTableKey" : "embodied_carbon_scope",
                                    "enumType" : "CarbonDataLifeCycleStagesAnswerType",
                                    "options" : [
                                        {
                                            "description" : "Product Stage (Cradle-to-Gate) A1-A3",
                                            "value" : "ProductStage"
                                        },
                                        {
                                            "description" : "Construction Stage A4-A5",
                                            "value" : "ConstructionStage"
                                        },
                                        {
                                            "description" : "Use Stage B1-B5",
                                            "value" : "UseStage"
                                        },
                                        {
                                            "description" : "End of Life Stage C1-D4",
                                            "value" : "EndOfLifeStage"
                                        },
                                        {
                                            "description" : "Reuse\/Recovery\/Recycling Potential D",
                                            "value" : "ReuseRecoveryRecyclingPotential"
                                        }
                                    ]
                                },
                                {
                                    "type" : FieldType.MultipleFiles,
                                    "label" : "Embodied Carbon Supporting Documents",
                                    "instructions" : "",
                                    "summaryDataTableKey" : "embodied_carbon_supporting_files",
                                    "isExportable" : false,
                                    "inventoryFileType" : InventoryFileType.SustainabilityFile
                                }
                            ]
                        }
                    ]
                },
                {
                    "title" : "Water Use",
                    "questionnairePageType" : "SustainabilityWaterUse",
                    "fields" : [
                        {
                            "type" : FieldType.TextInput,
                            "label" : "Amount of water (usually liters)",
                            "instructions" : "",
                            "summaryDataTableKey" : "water_use_amount"
                        },
                        {
                            "type" : FieldType.TextInput,
                            "label" : "Water Use Product Unit",
                            "instructions" : "",
                            "summaryDataTableKey" : "water_use_product_unit"
                        },
                        {
                            "type" : FieldType.MultiSelectInput,
                            "label" : "Water Use Scope",
                            "instructions" : "",
                            "summaryDataTableKey" : "water_use_scope",
                            "enumType" : "CarbonDataLifeCycleStagesAnswerType",
                            "options" : [
                                {
                                    "description" : "Product Stage (Cradle-to-Gate) A1-A3",
                                    "value" : "ProductStage"
                                },
                                {
                                    "description" : "Construction Stage A4-A5",
                                    "value" : "ConstructionStage"
                                },
                                {
                                    "description" : "Use Stage B1-B5",
                                    "value" : "UseStage"
                                },
                                {
                                    "description" : "End of Life Stage C1-D4",
                                    "value" : "EndOfLifeStage"
                                },
                                {
                                    "description" : "Reuse\/Recovery\/Recycling Potential D",
                                    "value" : "ReuseRecoveryRecyclingPotential"
                                }
                            ]
                        },
                        {
                            "type" : FieldType.MultipleFiles,
                            "label" : "Water Use Supporting Documents",
                            "instructions" : "",
                            "summaryDataTableKey" : "water_use_supporting_files",
                            "isExportable" : false,
                            "inventoryFileType" : InventoryFileType.SustainabilityFile
                        }
                    ]
                },
                {
                    "title" : "Transparency",
                    "questionnairePageType" : "SustainabilityTransparency",
                    "fields" : [
                        {
                            "type" : FieldType.RadioButtons,
                            "label" : "Is the EPD third party reviewed and verified?",
                            "instructions" : "",
                            "summaryDataTableKey" : "carbon_data_transparency_third_party_verified",
                            "enumType" : "YesNoRadioOptions",
                            "options" : [
                                {
                                    "description" : "Yes, Third-Party (Externally Verified)",
                                    "value" : "Yes"
                                },
                                {
                                    "description" : "No, Internally Reviewed",
                                    "value" : "No"
                                }
                            ]
                        },
                        {
                            "type" : FieldType.TextInput,
                            "label" : "Timeframe\/Lifetime utilized in the EPD\/LCA",
                            "instructions" : "Enter the time in years",
                            "summaryDataTableKey" : "carbon_data_transparency_timeframe"
                        },
                        {
                            "type" : FieldType.RadioButtons,
                            "label" : "Is it plant specific?",
                            "instructions" : "",
                            "summaryDataTableKey" : "carbon_data_transparency_plant_specific",
                            "enumType" : "YesNoRadioOptions",
                            "options" : [
                                {
                                    "description" : "Yes",
                                    "value" : "Yes"
                                },
                                {
                                    "description" : "No",
                                    "value" : "No"
                                }
                            ]
                        },
                        {
                            "type" : FieldType.SingleSelectInput,
                            "label" : "Does the LCA\/EPD communicate changes in carbon based on variations\/configurations?",
                            "instructions" : "",
                            "summaryDataTableKey" : "carbon_data_transparency_variation",
                            "enumType" : "CarbonDataVariationAnswerType",
                            "options" : [
                                {
                                    "description" : "Based on SKU",
                                    "value" : "BasedOnSku"
                                },
                                {
                                    "description" : "Based on Product Feature",
                                    "value" : "BasedOnProductFeature"
                                },
                                {
                                    "description" : "Product Family",
                                    "value" : "ProductFamily"
                                },
                                {
                                    "description" : "Other",
                                    "value" : "Other"
                                },
                                {
                                    "description" : "No",
                                    "value" : "No"
                                }
                            ]
                        },
                        {
                            "type" : FieldType.RadioButtons,
                            "label" : "Is the product available in digital tools (EC3, OpenEPD, ILCD+EPD, ISO 22057, etc)",
                            "instructions" : "",
                            "summaryDataTableKey" : "carbon_data_transparency_digital_tools",
                            "enumType" : "CarbonDataDigitalToolsAnswerType",
                            "options" : [
                                {
                                    "description" : "Yes, Third-Party Verified",
                                    "value" : "YesThirdParty"
                                },
                                {
                                    "description" : "No, Not Third-Party Verified",
                                    "value" : "NoThirdParty"
                                },
                                {
                                    "description" : "ISO22057 Digital Data Alignment for BIM",
                                    "value" : "Iso22057"
                                },
                                {
                                    "description" : "In Progress",
                                    "value" : "InProgress"
                                },
                                {
                                    "description" : "No",
                                    "value" : "No"
                                }
                            ]
                        },
                        {
                            "type" : FieldType.RadioButtons,
                            "label" : "LCA Standard",
                            "instructions" : "",
                            "summaryDataTableKey" : "carbon_data_transparency_lca_standard",
                            "childFields" : [
                                {
                                    "type" : FieldType.TextInput,
                                    "label" : "Enter Equivalent",
                                    "instructions" : "",
                                    "summaryDataTableKey" : "carbon_datatransparency__lca_standard"
                                }
                            ],
                            "enumType" : "CarbonDataLcaStandardAnswerType",
                            "options" : [
                                {
                                    "description" : "ISO 14040 + ISO 14044",
                                    "value" : "Iso14040Iso14044"
                                },
                                {
                                    "description" : "ISO 14067",
                                    "value" : "Iso14067"
                                },
                                {
                                    "description" : "Equivalent",
                                    "value" : "Equivalent"
                                },
                                {
                                    "description" : "No\/Unknown",
                                    "value" : "NoUnknown"
                                }
                            ]
                        },
                        {
                            "type" : FieldType.RadioButtons,
                            "label" : "EPD Reporting Standard",
                            "instructions" : "Does the EPD comply with specific reporting standards?",
                            "summaryDataTableKey" : "carbon_data_transparency_epd_standard",
                            "enumType" : "CarbonDataEpdStandardAnswerType",
                            "options" : [
                                {
                                    "description" : "ISO 14025",
                                    "value" : "Iso14025"
                                },
                                {
                                    "description" : "ISO 21930",
                                    "value" : "Iso21930"
                                },
                                {
                                    "description" : "EN 15804",
                                    "value" : "En15804"
                                },
                                {
                                    "description" : "Unknown",
                                    "value" : "Unknown"
                                }
                            ]
                        },
                        {
                            "type" : FieldType.RadioButtons,
                            "label" : "Does the document include the name of the product?",
                            "instructions" : "",
                            "summaryDataTableKey" : "carbon_data_transparency_document_include_name",
                            "enumType" : "YesNoRadioOptions",
                            "options" : [
                                {
                                    "description" : "Yes",
                                    "value" : "Yes"
                                },
                                {
                                    "description" : "No",
                                    "value" : "No"
                                }
                            ]
                        }
                    ]
                },
                {
                    "title" : "Assessment & Commitments",
                    "questionnairePageType" : "SustainabilityAssessment",
                    "fields" : [
                        {
                            "type" : FieldType.RadioButtons,
                            "label" : "Has uncertainty been factored into A1-A3 stages? (EC3)",
                            "instructions" : "",
                            "summaryDataTableKey" : "carbon_data_assessment_uncertainty",
                            "enumType" : "CarbonDataUncertaintyAnswerType",
                            "options" : [
                                {
                                    "description" : "Yes; WRI Measuring embodied emissions",
                                    "value" : "YesMeasuringEmbodiedEmissions"
                                },
                                {
                                    "description" : "Yes; Burden of Doubt",
                                    "value" : "YesBurdenOfDoubt"
                                },
                                {
                                    "description" : "In Progress",
                                    "value" : "InProgress"
                                },
                                {
                                    "description" : "No",
                                    "value" : "No"
                                }
                            ]
                        },
                        {
                            "type" : FieldType.RadioButtons,
                            "label" : "Are there other stages where uncertainty can be applied?",
                            "instructions" : "",
                            "summaryDataTableKey" : "carbon_data_assessment_uncertainty_additional",
                            "enumType" : "CarbonDataUncertaintyAnswerType",
                            "options" : [
                                {
                                    "description" : "Yes; WRI Measuring embodied emissions",
                                    "value" : "YesMeasuringEmbodiedEmissions"
                                },
                                {
                                    "description" : "Yes; Burden of Doubt",
                                    "value" : "YesBurdenOfDoubt"
                                },
                                {
                                    "description" : "In Progress",
                                    "value" : "InProgress"
                                },
                                {
                                    "description" : "No",
                                    "value" : "No"
                                }
                            ]
                        },
                        {
                            "type" : FieldType.RadioButtons,
                            "label" : "What steps are being taken to improve impacts?",
                            "instructions" : "",
                            "summaryDataTableKey" : "carbon_data_commitment_action_plan",
                            "enumType" : "CarbonDataActionPlanAnswerTypes",
                            "options" : [
                                {
                                    "description" : "Action Plan Complete",
                                    "value" : "ActionPlanComplete"
                                },
                                {
                                    "description" : "In Progress",
                                    "value" : "InProgress"
                                },
                                {
                                    "description" : "No",
                                    "value" : "No"
                                }
                            ]
                        }
                    ]
                },
                {
                    "title" : "Optimizations",
                    "questionnairePageType" : "SustainabilityOptimization",
                    "fields" : [
                        {
                            "type" : FieldType.RadioButtons,
                            "label" : "Is there a baseline established for this product category?",
                            "instructions" : "",
                            "summaryDataTableKey" : "carbon_data_optimizations_is_clf_baseline_established",
                            "childFields" : [
                                {
                                    "type" : FieldType.TextInput,
                                    "label" : "What is the value?",
                                    "instructions" : "",
                                    "summaryDataTableKey" : "carbon_data_optimizations_clf_baseline"
                                },
                                {
                                    "type" : FieldType.TextInput,
                                    "label" : "What category\/compositional value was selected for the above baseline?",
                                    "instructions" : "",
                                    "summaryDataTableKey" : "carbon_data_optimizations_clf_baseline_category"
                                }
                            ],
                            "enumType" : "YesNoRadioOptions",
                            "options" : [
                                {
                                    "description" : "Yes",
                                    "value" : "Yes"
                                },
                                {
                                    "description" : "No",
                                    "value" : "No"
                                }
                            ]
                        },
                        {
                            "type" : FieldType.RadioButtons,
                            "label" : "Is there an Achievable Estimate Established?",
                            "instructions" : "",
                            "summaryDataTableKey" : "carbon_data_optimizations_is_clf_achievable_estimate_established",
                            "childFields" : [
                                {
                                    "type" : FieldType.TextInput,
                                    "label" : "CLF \"Achievable\" Estimate - 20th Percentile Value",
                                    "instructions" : "",
                                    "summaryDataTableKey" : "carbon_data_optimizations_clf_achievable_estimate"
                                },
                                {
                                    "type" : FieldType.TextInput,
                                    "label" : "What category\/compositional value was selected for the estimate?",
                                    "instructions" : "",
                                    "summaryDataTableKey" : "carbon_data_optimizations_clf_achievable_estimate_category"
                                }
                            ],
                            "enumType" : "YesNoRadioOptions",
                            "options" : [
                                {
                                    "description" : "Yes",
                                    "value" : "Yes"
                                },
                                {
                                    "description" : "No",
                                    "value" : "No"
                                }
                            ]
                        },
                        {
                            "type" : FieldType.TextInput,
                            "label" : "Percentage of Reductions from CLF Baseline",
                            "instructions" : "Please Enter a Percentage",
                            "summaryDataTableKey" : "carbon_data_optimizations_percentage_reduction_clf_baseline"
                        },
                        {
                            "type" : FieldType.TextInput,
                            "label" : "What percentile does this product fall in for the given category?",
                            "instructions" : "If the percentage falls below the 20%, this could be considered a threshold for optimization",
                            "summaryDataTableKey" : "carbon_data_optimizations_percentile_achievement_level"
                        },
                        {
                            "type" : FieldType.SelectCertification,
                            "label" : "GHG Emissions Reduction Certification",
                            "instructions" : "Adding a certification here will also link it to your product\/material. You can view it in the \"Certifications\" page on the left.",
                            "summaryDataTableKey" : "carbon_data_optimizations_ghg_certification_id"
                        },
                        {
                            "type" : FieldType.TextInput,
                            "label" : "GHG Emissions Reduction from Previous Baseline (Final Manuf Stage)",
                            "instructions" : "Enter percentage of reduction from Baseline value entered above",
                            "summaryDataTableKey" : "carbon_data_optimizations_ghg_emissions_reduction_from_previous_baseline_final_manuf_stage"
                        },
                        {
                            "type" : FieldType.TextInput,
                            "label" : "GHG Emissions Reduction from Previous Baseline (Cradle to Gate; LCA)",
                            "instructions" : "Enter percentage of reduction from Baseline value entered above",
                            "summaryDataTableKey" : "carbon_data_optimizations_ghg_emissions_reduction_from_previous_baseline_c2g"
                        },
                        {
                            "type" : FieldType.TextInput,
                            "label" : "What % of your product have you Offset? (0 to 200%)",
                            "instructions" : "",
                            "summaryDataTableKey" : "carbon_data_optimizations_offsets_percentage"
                        },
                        {
                            "type" : FieldType.MultipleFiles,
                            "label" : "Documentation or third-party verification of Offsets",
                            "instructions" : "",
                            "summaryDataTableKey" : "carbon_data_optimizations_offsets_verification_document_files",
                            "inventoryFileType" : InventoryFileType.SustainabilityFile
                        },
                        {
                            "type" : FieldType.SelectCertification,
                            "label" : "Carbon Neutral or Carbon Positive Certification",
                            "instructions" : "Adding a certification here will also link it to your product\/material. You can view it in the \"Certifications\" page on the left.",
                            "summaryDataTableKey" : "carbon_data_optimizations_carbon_neutral_positive_certification_id",
                            "isExportable" : false
                        },
                        {
                            "type" : FieldType.RadioButtons,
                            "label" : "Is the certification for Carbon Neutral or Positive (handprinting)?",
                            "instructions" : "",
                            "summaryDataTableKey" : "carbon_data_optimizations_carbon_neutral_positive_certification_type",
                            "isExportable" : false,
                            "enumType" : "CarbonDataCarbonNeutralOrPositiveAnswerType",
                            "options" : [
                                {
                                    "description" : "Carbon Neutral",
                                    "value" : "CarbonNeutral"
                                },
                                {
                                    "description" : "Carbon Positive",
                                    "value" : "CarbonPositive"
                                }
                            ]
                        },
                        {
                            "type" : FieldType.RadioButtons,
                            "label" : "Is the product's Carbon Neutral or Carbon Positive status third party verified?",
                            "instructions" : "",
                            "summaryDataTableKey" : "carbon_data_optimizations_carbon_neutral_positive_verification_type",
                            "enumType" : "CarbonDataThirdPartyVerifiedAnswerType",
                            "options" : [
                                {
                                    "description" : "Yes, Third-Party (Externally Verified)",
                                    "value" : "ThirdParty"
                                },
                                {
                                    "description" : "No, Internally Reviewed",
                                    "value" : "NotThirdParty"
                                }
                            ]
                        },
                        {
                            "type" : FieldType.TextInput,
                            "label" : "Enter Carbon reduction percentage",
                            "instructions" : "Enter percentage through supply chain or other handprinting, i.e. tree planting, habitat restoration\/soil amendment, supply chain efficiency (per LPC14)",
                            "summaryDataTableKey" : "carbon_data_optimizations_handprint_reduction_percentage"
                        },
                        {
                            "type" : FieldType.RadioButtons,
                            "label" : "Does the product contain any Biogenic Carbon or is it Actively Carbon Absorbing?",
                            "instructions" : "",
                            "summaryDataTableKey" : "carbon_data_optimizations_biogenic",
                            "enumType" : "CarbonDataBiogenicCarbonAnswerType",
                            "options" : [
                                {
                                    "description" : "Contains Biogenic Carbon",
                                    "value" : "ContainsBiogenicCarbon"
                                },
                                {
                                    "description" : "Actively Carbon Absorbing",
                                    "value" : "ActivelyCarbonAbsorbing"
                                }
                            ]
                        },
                        {
                            "type" : FieldType.MultipleFiles,
                            "label" : "Provide a narrative and\/or research to support claims made about the Biogenic Carbon",
                            "instructions" : "",
                            "summaryDataTableKey" : "carbon_data_optimizations_biogenic_verification_files",
                            "isExportable" : false,
                            "inventoryFileType" : InventoryFileType.SustainabilityFile
                        },
                        {
                            "type" : FieldType.RadioButtons,
                            "label" : "Have these claims about Biogenic Carbon been 3rd party verified?",
                            "instructions" : "",
                            "summaryDataTableKey" : "carbon_data_optimizations_biogenic_verification_type",
                            "enumType" : "CarbonDataThirdPartyVerifiedAnswerType",
                            "options" : [
                                {
                                    "description" : "Yes, Third-Party (Externally Verified)",
                                    "value" : "NotThirdParty"
                                },
                                {
                                    "description" : "No, Internally Reviewed",
                                    "value" : "ThirdParty"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "title" : "VOC Data",
            "questionnairePageType" : "VocAll",
            "sections" : [
                {
                    "title" : "Transparency",
                    "questionnairePageType" : "VocTransparency",
                    "fields" : [
                        {
                            "type" : FieldType.MultiSelectInput,
                            "label" : "What types of VOC testing are relevant to this product type?",
                            "instructions" : "",
                            "summaryDataTableKey" : "voc_transparency_testing",
                            "childFields" : [
                                {
                                    "type" : FieldType.RadioButtons,
                                    "label" : "Was testing completed for VOC content? If so, provide value (g\/L) and link to documents.",
                                    "instructions" : "",
                                    "summaryDataTableKey" : "voc_transparency_testing_content",
                                    "childFields" : [
                                        {
                                            "type" : FieldType.TextInput,
                                            "label" : "VOC Content (g\/L)",
                                            "instructions" : "",
                                            "summaryDataTableKey" : "voc_transparency_testing_content_amount"
                                        },
                                        {
                                            "type" : FieldType.SelectCertification,
                                            "label" : "VOC Testing Certification",
                                            "instructions" : "Adding a certification here will also link it to your product\/material. You can view it in the \"Certifications\" page on the left.",
                                            "summaryDataTableKey" : "voc_transparency_testing_content_amount_certification_id",
                                            "isExportable" : false
                                        }
                                    ],
                                    "enumType" : "YesNoNaRadioOptions",
                                    "options" : [
                                        {
                                            "description" : "Yes",
                                            "value" : "Yes"
                                        },
                                        {
                                            "description" : "No",
                                            "value" : "No"
                                        },
                                        {
                                            "description" : "N\/A",
                                            "value" : "Na"
                                        }
                                    ]
                                }
                            ],
                            "enumType" : "VocApplicableTestingEnum",
                            "options" : [
                                {
                                    "description" : "VOC Content",
                                    "value" : "VocContent"
                                },
                                {
                                    "description" : "VOC Emissions",
                                    "value" : "VocEmmisions"
                                },
                                {
                                    "description" : "Formaldehyde Emissions",
                                    "value" : "Formaldehyde"
                                },
                                {
                                    "description" : "Inherently Non-Emitting",
                                    "value" : "NonEmitting"
                                }
                            ]
                        },
                        {
                            "type" : FieldType.RadioButtons,
                            "label" : "Was testing completed for VOC emissions? If so, provide link to documents.",
                            "instructions" : "",
                            "summaryDataTableKey" : "voc_transparency_testing_emissions",
                            "childFields" : [
                                {
                                    "type" : FieldType.SelectCertification,
                                    "label" : "VOC Testing Emissions Certification",
                                    "instructions" : "Adding a certification here will also link it to your product\/material. You can view it in the \"Certifications\" page on the left.",
                                    "summaryDataTableKey" : "voc_transparency_emissions_certification_id",
                                    "isExportable" : false
                                }
                            ],
                            "enumType" : "YesNoNaRadioOptions",
                            "options" : [
                                {
                                    "description" : "Yes",
                                    "value" : "Yes"
                                },
                                {
                                    "description" : "No",
                                    "value" : "No"
                                },
                                {
                                    "description" : "N\/A",
                                    "value" : "Na"
                                }
                            ]
                        },
                        {
                            "type" : FieldType.RadioButtons,
                            "label" : "Was testing completed for Formaldehyde emissions? If so, provide link to documents.",
                            "instructions" : "",
                            "summaryDataTableKey" : "voc_transparency_testing_formaldehyde",
                            "childFields" : [
                                {
                                    "type" : FieldType.SelectCertification,
                                    "label" : "VOC Testing Formaldehyde Emissions Certification",
                                    "instructions" : "Adding a certification here will also link it to your product\/material. You can view it in the \"Certifications\" page on the left.",
                                    "summaryDataTableKey" : "voc_transparency_formaldehyde_certification_id",
                                    "isExportable" : false
                                }
                            ],
                            "enumType" : "YesNoNaRadioOptions",
                            "options" : [
                                {
                                    "description" : "Yes",
                                    "value" : "Yes"
                                },
                                {
                                    "description" : "No",
                                    "value" : "No"
                                },
                                {
                                    "description" : "N\/A",
                                    "value" : "Na"
                                }
                            ]
                        },
                        {
                            "type" : FieldType.RadioButtons,
                            "label" : "Was VOC testing completed and are documents publicly available for all applicable types of testing (content, emissions, formaldehyde)?",
                            "instructions" : "\"Partial Testing\" indicates product has completed one form of testing but not all forms applicable to the product type.",
                            "summaryDataTableKey" : "voc_transparency",
                            "enumType" : "VocTransparencyEnum",
                            "options" : [
                                {
                                    "description" : "Complete Testing",
                                    "value" : "CompleteTesting"
                                },
                                {
                                    "description" : "Partial Testing",
                                    "value" : "PartialTesting"
                                },
                                {
                                    "description" : "Incomplete Testing",
                                    "value" : "IncompleteTesting"
                                },
                                {
                                    "description" : "N\/A",
                                    "value" : "Na"
                                }
                            ]
                        }
                    ]
                },
                {
                    "title" : "Assessment & Commitments",
                    "questionnairePageType" : "VocAssessment",
                    "fields" : [
                        {
                            "type" : FieldType.RadioButtons,
                            "label" : "Does the product comply with SCAQMD regulations for VOC content?",
                            "instructions" : "",
                            "summaryDataTableKey" : "voc_assessment_comply_scaqmd",
                            "enumType" : "YesNoNaRadioOptions",
                            "options" : [
                                {
                                    "description" : "Yes",
                                    "value" : "Yes"
                                },
                                {
                                    "description" : "No",
                                    "value" : "No"
                                },
                                {
                                    "description" : "N\/A",
                                    "value" : "Na"
                                }
                            ]
                        },
                        {
                            "type" : FieldType.RadioButtons,
                            "label" : "Does the product comply with the CDPH Standard Method V1.2-2017 (or equivalent) for VOC emissions? If so, provide testing methodology and reporting program.",
                            "instructions" : "",
                            "summaryDataTableKey" : "voc_assessment_comply_cdph",
                            "enumType" : "YesNoNaRadioOptions",
                            "options" : [
                                {
                                    "description" : "Yes",
                                    "value" : "Yes"
                                },
                                {
                                    "description" : "No",
                                    "value" : "No"
                                },
                                {
                                    "description" : "N\/A",
                                    "value" : "Na"
                                }
                            ]
                        },
                        {
                            "type" : FieldType.RadioButtons,
                            "label" : "Testing Methodology or Standard",
                            "instructions" : "",
                            "summaryDataTableKey" : "voc_assessment_testing_methodology",
                            "enumType" : "VocTestingMethodologyEnum",
                            "options" : [
                                {
                                    "description" : "CDPH Standard Method V1.2-2017",
                                    "value" : "CdphStandardMethod2017"
                                },
                                {
                                    "description" : "BIFMA Level - Credit 7.6.3",
                                    "value" : "Bifma"
                                },
                                {
                                    "description" : "Cradle to Cradle (gold + platinum levels)",
                                    "value" : "C2c"
                                },
                                {
                                    "description" : "FloorScore",
                                    "value" : "FloorScore"
                                },
                                {
                                    "description" : "GreenGuard (all levels)",
                                    "value" : "GreenGuard"
                                },
                                {
                                    "description" : "Indoor Advantage (all levels)",
                                    "value" : "IndoorAdvantage"
                                },
                                {
                                    "description" : "NSF 332 (all levels)",
                                    "value" : "NSF332"
                                },
                                {
                                    "description" : "MAS Certified Green",
                                    "value" : "MasCertifiedGreen"
                                },
                                {
                                    "description" : "Intertek Clean Air - Gold",
                                    "value" : "IntertekCleanAirGold"
                                },
                                {
                                    "description" : "GreenSeal GS-11 Certification",
                                    "value" : "GreenSealGs11"
                                }
                            ]
                        },
                        {
                            "type" : FieldType.RadioButtons,
                            "label" : "Reporting Body",
                            "instructions" : "",
                            "summaryDataTableKey" : "voc_assessment_reporting_body",
                            "enumType" : "VocReportingBodyEnum",
                            "options" : [
                                {
                                    "description" : "Berkeley Analytical",
                                    "value" : "BerkeleyAnalytical"
                                },
                                {
                                    "description" : "BIFMA",
                                    "value" : "Bifma"
                                },
                                {
                                    "description" : "Cradle to Cradle",
                                    "value" : "C2c"
                                },
                                {
                                    "description" : "UL Environment",
                                    "value" : "UlEnvironment"
                                },
                                {
                                    "description" : "SCS Global Services",
                                    "value" : "ScsGlobalServices"
                                },
                                {
                                    "description" : "MAS Certified Green",
                                    "value" : "MasCertifiedGreen"
                                },
                                {
                                    "description" : "Intertek",
                                    "value" : "Intertek"
                                },
                                {
                                    "description" : "GreenSeal",
                                    "value" : "GreenSeal"
                                }
                            ]
                        },
                        {
                            "type" : FieldType.RadioButtons,
                            "label" : "Emissions Testing Scenario",
                            "instructions" : "",
                            "summaryDataTableKey" : "voc_assessment_emissions_testing_scenario",
                            "enumType" : "VocEmissionsTestingEnum",
                            "options" : [
                                {
                                    "description" : "Classroom",
                                    "value" : "Classroom"
                                },
                                {
                                    "description" : "Office",
                                    "value" : "Office"
                                },
                                {
                                    "description" : "Residential",
                                    "value" : "Residential"
                                },
                                {
                                    "description" : "N\/A-Pass",
                                    "value" : "Na"
                                }
                            ]
                        },
                        {
                            "type" : FieldType.RadioButtons,
                            "label" : "Does the product comply with CARB Phase 2 Formaldehyde requirements?",
                            "instructions" : "",
                            "summaryDataTableKey" : "voc_assessment_carb_formaldehyde",
                            "childFields" : [
                                {
                                    "type" : FieldType.MultipleFiles,
                                    "label" : "CARB Phase 2 Formaldehyde Documentation",
                                    "instructions" : "",
                                    "summaryDataTableKey" : "voc_assessment_carb_formaldehyde_documentation_files",
                                    "isExportable" : false,
                                    "inventoryFileType" : InventoryFileType.VocDataFile
                                },
                                {
                                    "type" : FieldType.RadioButtons,
                                    "label" : "CARB Phase 2 Formaldehyde Certification\/Standard",
                                    "instructions" : "",
                                    "summaryDataTableKey" : "voc_assessment_certification_standard",
                                    "enumType" : "VocCertificationOptionsEnum",
                                    "options" : [
                                        {
                                            "description" : "No Added Formaldehyde (NAF)",
                                            "value" : "NoAddedFormaldehyde"
                                        },
                                        {
                                            "description" : "Ultra-Low-Emitting Formaldehyde (ULEF)",
                                            "value" : "UltraLowEmittingFormaldehyde"
                                        },
                                        {
                                            "description" : "PS 1-09 (wood structural panel)",
                                            "value" : "PS109"
                                        },
                                        {
                                            "description" : "PS 2-10 (wood structural panel)",
                                            "value" : "PS210"
                                        },
                                        {
                                            "description" : "ASTM D 5456 (for structural composite lumber)",
                                            "value" : "AstmD5456"
                                        },
                                        {
                                            "description" : "ANSI A190.1 (for glued laminated timber)",
                                            "value" : "AnsiA1901"
                                        },
                                        {
                                            "description" : "ASTM D 5055 (for I-joists)",
                                            "value" : "AstmD5055"
                                        },
                                        {
                                            "description" : "ANSI PRG 320 (for cross-laminated timber)",
                                            "value" : "AnsiPrg320"
                                        },
                                        {
                                            "description" : "PS 20-15 (for finger-jointed lumber)",
                                            "value" : "Ps2015"
                                        }
                                    ]
                                },
                                {
                                    "type" : FieldType.RadioButtons,
                                    "label" : "Has the product been assessed\/verified to comply with the major industry VOC standards?",
                                    "instructions" : "\"Partial Compliance\" indicates product is compliant in one form of testing but not all forms applicable to the product type.",
                                    "summaryDataTableKey" : "voc_assessment",
                                    "enumType" : "VocAssessmentEnum",
                                    "options" : [
                                        {
                                            "description" : "Full Compliance",
                                            "value" : "FullCompliance"
                                        },
                                        {
                                            "description" : "Partial Compliance",
                                            "value" : "PartialCompliance"
                                        },
                                        {
                                            "description" : "Non-Compliant",
                                            "value" : "NonCompliant"
                                        },
                                        {
                                            "description" : "N\/A",
                                            "value" : "Na"
                                        }
                                    ]
                                }
                            ],
                            "enumType" : "YesNoNaRadioOptions",
                            "options" : [
                                {
                                    "description" : "Yes",
                                    "value" : "Yes"
                                },
                                {
                                    "description" : "No",
                                    "value" : "No"
                                },
                                {
                                    "description" : "N\/A",
                                    "value" : "Na"
                                }
                            ]
                        },
                        {
                            "type" : FieldType.RadioButtons,
                            "label" : "If VOC testing is not complete, is it actively in progress?",
                            "instructions" : "",
                            "summaryDataTableKey" : "voc_commitments",
                            "enumType" : "VocCommitmentsOptionsEnum",
                            "options" : [
                                {
                                    "description" : "Complete",
                                    "value" : "Complete"
                                },
                                {
                                    "description" : "In Progress",
                                    "value" : "InProgress"
                                },
                                {
                                    "description" : "N\/A",
                                    "value" : "Na"
                                }
                            ]
                        },
                        {
                            "type" : FieldType.MultipleFiles,
                            "label" : "Action Plan",
                            "instructions" : "",
                            "summaryDataTableKey" : "voc_commitments_action_plan_files",
                            "isExportable" : false,
                            "inventoryFileType" : InventoryFileType.VocDataFile
                        }
                    ]
                },
                {
                    "title" : "Optimization",
                    "questionnairePageType" : "VocOptimization",
                    "fields" : [
                        {
                            "type" : FieldType.RadioButtons,
                            "label" : "Does the product comply with one of the following emissions standards that goes beyond the CDPH standard?",
                            "instructions" : "",
                            "summaryDataTableKey" : "voc_optimization_further_standard",
                            "enumType" : "VocOptimizationEmissionsEnum",
                            "options" : [
                                {
                                    "description" : "UL Greenguard Gold",
                                    "value" : "ULGreenguardGold"
                                },
                                {
                                    "description" : "CRI Green Label Plus",
                                    "value" : "CriGreenLabelPlus"
                                },
                                {
                                    "description" : "C2C Platinum",
                                    "value" : "C2cPlatinum"
                                },
                                {
                                    "description" : "C2C Gold",
                                    "value" : "C2cGold"
                                },
                                {
                                    "description" : "Green Seal Certification",
                                    "value" : "GreenSealCertification"
                                },
                                {
                                    "description" : "N\/A",
                                    "value" : "Na"
                                }
                            ]
                        },
                        {
                            "type" : FieldType.RadioButtons,
                            "label" : "Has the product been tested for TVOCs meeting one of the following benchmarks?",
                            "instructions" : "",
                            "summaryDataTableKey" : "voc_optimization_tvoc",
                            "enumType" : "VocOptimizationTvocEmissionsEnum",
                            "options" : [
                                {
                                    "description" : "0.22 mg\/m3 or less",
                                    "value" : "LessThan22"
                                },
                                {
                                    "description" : "0.5 mg\/m3 or less",
                                    "value" : "LessThanHalf"
                                },
                                {
                                    "description" : "Between 0.5 and 5.0 mg\/m3",
                                    "value" : "BetweenHalfAnd5"
                                },
                                {
                                    "description" : "5.0 mg\/m3 or more",
                                    "value" : "MoreThan5"
                                },
                                {
                                    "description" : "N\/A",
                                    "value" : "Na"
                                }
                            ]
                        },
                        {
                            "type" : FieldType.RadioButtons,
                            "label" : "Is the product certified NAF by CARB Phase 2 standards?",
                            "instructions" : "",
                            "summaryDataTableKey" : "voc_optimization_formaldehyde",
                            "enumType" : "VocOptimizationFormaldehydeEnum",
                            "options" : [
                                {
                                    "description" : "NAF Certified",
                                    "value" : "NafCertified"
                                },
                                {
                                    "description" : "No",
                                    "value" : "No"
                                },
                                {
                                    "description" : "N\/A",
                                    "value" : "Na"
                                }
                            ]
                        },
                        {
                            "type" : FieldType.SelectCertification,
                            "label" : "CARB Phase 2 Standards Certification",
                            "instructions" : "Adding a certification here will also link it to your product\/material. You can view it in the \"Certifications\" page on the left.",
                            "summaryDataTableKey" : "voc_optimization_formaldehyde_certification_id",
                            "isExportable" : false
                        },
                        {
                            "type" : FieldType.RadioButtons,
                            "label" : "Is the product determined to be \"Super Compliant\" by SCAQMD standards?",
                            "instructions" : "",
                            "summaryDataTableKey" : "voc_optimization_supercompliant",
                            "enumType" : "YesNoNaRadioOptions",
                            "options" : [
                                {
                                    "description" : "Yes",
                                    "value" : "Yes"
                                },
                                {
                                    "description" : "No",
                                    "value" : "No"
                                },
                                {
                                    "description" : "N\/A",
                                    "value" : "Na"
                                }
                            ]
                        },
                        {
                            "type" : FieldType.SelectCertification,
                            "label" : "SCAQMD Standards Certification",
                            "instructions" : "Adding a certification here will also link it to your product\/material. You can view it in the \"Certifications\" page on the left.",
                            "summaryDataTableKey" : "voc_optimization_supercompliant_certification_id",
                            "isExportable" : false
                        },
                        {
                            "type" : FieldType.RadioButtons,
                            "label" : "Does the product meet above-average standards in all applicable forms of VOC testing?",
                            "instructions" : "Mark as fully optimized if the above three certifications are included.",
                            "summaryDataTableKey" : "voc_optimization",
                            "enumType" : "VocOptimizationOptionsEnum",
                            "options" : [
                                {
                                    "description" : "Full Optimization",
                                    "value" : "FullOptimization"
                                },
                                {
                                    "description" : "Partial Optimization",
                                    "value" : "PartialOptimization"
                                },
                                {
                                    "description" : "N\/A",
                                    "value" : "Na"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "title" : "Instructions",
            "questionnairePageType" : "InstructionsAll",
            "sections" : [
                {
                    "title" : "Installation",
                    "questionnairePageType" : "InstructionsInstallation",
                    "fields" : [
                        {
                            "type" : FieldType.MultipleFiles,
                            "label" : "Installation Files",
                            "instructions" : "",
                            "summaryDataTableKey" : "instructions_installation_files",
                            "isExportable" : false,
                            "inventoryFileType" : InventoryFileType.InstructionsFile
                        },
                        {
                            "type" : FieldType.TextInput,
                            "label" : "Installation Notes",
                            "instructions" : "",
                            "summaryDataTableKey" : "instructions_installation_notes"
                        }
                    ]
                },
                {
                    "title" : "Use Phase",
                    "questionnairePageType" : "InstructionsUsePhase",
                    "fields" : [
                        {
                            "type" : FieldType.TextInput,
                            "label" : "Life Expectancy",
                            "instructions" : "",
                            "summaryDataTableKey" : "instructions_use_phase_life_expectancy"
                        },
                        {
                            "type" : FieldType.FieldGroup,
                            "label" : "Warranty Info",
                            "instructions" : "",
                            "childFields" : [
                                {
                                    "type" : FieldType.MultipleFiles,
                                    "label" : "Warranty Files",
                                    "instructions" : "",
                                    "summaryDataTableKey" : "instructions_use_phase_warranty_files",
                                    "isExportable" : false,
                                    "inventoryFileType" : InventoryFileType.InstructionsFile
                                },
                                {
                                    "type" : FieldType.TextInput,
                                    "label" : "Warranty Notes",
                                    "instructions" : "",
                                    "summaryDataTableKey" : "instructions_use_phase_warranty_notes"
                                }
                            ]
                        }
                    ]
                },
                {
                    "title" : "Product Specifications",
                    "questionnairePageType" : "InstructionsSpecifications",
                    "fields" : [
                        {
                            "type" : FieldType.MultipleTextInputRows,
                            "label" : "Specifications",
                            "instructions" : "List out all specifications for this product. Click the plus button to get started",
                            "summaryDataTableKey" : "instructions_specifications",
                            "isExportable" : false
                        }
                    ]
                }
            ]
        }
    ]
};
    }
}